<template>
    <b-card>
        <b-alert variant="danger" :show="showAlert">
            {{ alert }}
        </b-alert>
        <b-alert variant="success" :show="showSuccessAlert">
            {{ alert }}
        </b-alert>
        <b-form @submit.prevent="setMode">
            <b-form-group>
                <b-form-radio-group v-model="formData.programMode">
                    <b-form-radio :value="false">{{ $t('kkm.workMode') }}</b-form-radio>
                    <b-form-radio :value="true">{{ $t('kkm.programMode') }}</b-form-radio>
                </b-form-radio-group>
                <b-form-row class="justify-content-end mx-0">
                    <b-button type="submit" variant="success" :disabled="isDisabled">
                        <save-icon title="" />&nbsp;{{ $t('general.save') }}
                    </b-button>
                </b-form-row>
            </b-form-group>
        </b-form>
    </b-card>
</template>

<script>
export default {
    name: 'SetModeForm',
    props: {
        kkmId: Number,
        programMode: Boolean
    },
    data () {
        return {
            showAlert: false,
            showSuccessAlert: false,
            alert: '',
            formData: {
                id: this.kkmId,
                programMode: this.programMode
            }
        }
    },
    computed: {
        isDisabled() {
            return this.$store.getters.isLoading
        }
    },
    methods: {
        setMode() {
            if (this.formData.programMode) {
                this.setProgramMode()
            } else {
                this.setWorkMode()
            }
        },
        setProgramMode() {
            this.hideAlert()
            this.$request.sendRequest(this, this.$appConfig.apiUrls.kkm.setProgramMode,
                this.formData, result => {
                    this.showSuccessAlert = true
                    this.alert = this.$i18n.t('kkm.programModeSetMessage')
                }, this.displayAlert)
        },
        setWorkMode() {
            this.hideAlert()
            this.$request.sendRequest(this, this.$appConfig.apiUrls.kkm.setWorkMode,
                this.formData, result => {
                    this.showSuccessAlert = true
                    this.alert = this.$i18n.t('kkm.workModeSetMessage')
                }, this.displayAlert)
        },
        hideAlert() {
            this.showAlert = false
            this.showSuccessAlert = false
            this.alert = ''
        },
        displayAlert(errorCode) {
            this.alert = this.$i18n.t(`errors.${errorCode}`)
            this.showAlert = true
        }
    }
}
</script>
